var hugmun;
(function($) {
  "use strict";
  hugmun = (function() {
    return {
      init: function() {
        // Project
        this.projectCarousel();
        this.projectVideos();

        // About
        this.about();

        // Footer
        this.footerProjects();
      },

      // Project
      projectCarousel: function () {
        $(".js-project-carousel").owlCarousel({
          loop: true,
          margin: 0,
          nav: true,
          items: 1,
          dots: false,
          autoplay: false
        }); 
        $(".js-project:not(.d-none) .js-project-carousel-dot:first-child").addClass("active");
        $(".js-project-carousel-dot span").on('animationend webkitAnimationEnd', function() {
          var id = parseInt($(this).attr("data-id"));
          var newId = id + 1;
          var carousel = $(this).closest(".js-project-carousel-wrap").find(".js-project-carousel");
          if($(this).closest(".js-project-carousel-wrap").find(".js-project-carousel-dot span[data-id='" + newId + "']").length > 0) {
            carousel.trigger('to.owl.carousel', id);
          } else {
            carousel.trigger('to.owl.carousel', 0);
          }
        });
        $(".js-project-carousel").on('changed.owl.carousel', function(e) {
          var index = (e.property.value - Math.ceil(e.item.count / 2)) % e.item.count || 0;
          $(this).closest(".js-project-carousel-wrap").find(".js-project-carousel-dot").removeClass("active");
          $(this).closest(".js-project-carousel-wrap").find(".js-project-carousel-dot").eq(index).addClass("active");
        });
        $(".js-back-project").click(function () {
          $(this).closest(".js-project").removeClass("clicked");
          return false;
        });
        $(".js-project-carousel").click(function (e) {
          var center = $(this).width() / 2;
          if (e.offsetX > center) {
            $(this).trigger('next.owl.carousel');
          } else {
            $(this).trigger('prev.owl.carousel');
          }
          return false;
        });
      },

      projectVideos: function() {
        setInterval(function () {
          $(".js-project-video").each(function () {
            if($(this).hasClass("lazyloaded")) {
              var videoUrl = $(this).attr("data-video-url");
              var that = $(this).parent();
              $(this).remove();
              var html = '<video autoplay muted loop playsinline class="project-video" width="740" height="740"><source src="' + videoUrl + '" type="video/mp4" /></video>';
              $(that).append(html);
            }
          })
        }, 500);
      },

      // About
      about: function() {
        $(".js-footer-company").click(function () {
          $(".project:not(.project--about)").addClass("unactive");
          $(".js-about").addClass("active");
          $(".js-about .js-project-carousel-dot:first-child").addClass("active");
          $(".js-about .js-project-carousel").each(function () {
            $(this).trigger('to.owl.carousel', 0);
          });
          $(".js-footer-company").addClass("mobile-active");
          setTimeout(function () {
            $(window).scrollTop(0);
          }, 200);
          return false;
        });
        $(".js-footer-home").click(function () {
          $(".js-change-project").eq(0).click();
        });
        $(".js-back-about, .js-footer-home").click(function () {
          $(".project:not(.project--about)").removeClass("unactive");
          $(".js-about").removeClass("active");
          $(".js-about .js-project-carousel-dot").removeClass("active");
          setTimeout(function () {
            $(window).scrollTop(0);
          }, 200);
          $(".js-footer-company").removeClass("mobile-active");
          return false;
        });
      },

      // Footer
      footerProjects: function() {
        if($(window).outerWidth() > 991) {
          setTimeout(function () {
            $(".js-change-project").each(function () {
              $(this).css("width", $(this).outerWidth());
            }); 
          }, 500);
        }
        $(".js-about-project").click(function () {
          $(this).addClass("clicked");
        });
        $(".js-change-project").click(function () {
          var projectId = $(this).attr("data-project-id");
          $(".js-project").addClass("d-none");
          $(".js-project[data-project-id='" + projectId + "']").removeClass("d-none");      
          $(".js-project .js-project-carousel-dot").removeClass("active");
          $(".js-project[data-project-id='" + projectId + "'] .js-project-carousel").each(function () {
            $(this).parent().find(".js-project-carousel-dot").eq(0).addClass("active");
            $(this).trigger('to.owl.carousel', 0);
          });
          $(".js-change-project").removeClass("active");
          $(this).addClass("active");
          if($(this).find(".js-about-project").hasClass("clicked")) {
            if($(window).outerWidth() > 991) {
              var projectId = $(this).closest(".js-change-project").attr("data-project-id");
              $(".js-project[data-project-id='" + projectId + "']").addClass("clicked");
            }
            $(this).find(".js-about-project").addClass("active");
            $(this).find(".js-about-project").removeClass("clicked");
          } else {
            $(".js-project[data-project-id='" + projectId + "']").removeClass("clicked");
            $(this).find(".js-about-project").removeClass("active");
          }
          setTimeout(function () {
            $(window).scrollTop(0);
          }, 200);
          $(".project:not(.project--about)").removeClass("unactive");
          $(".js-about").removeClass("active");
          $(".js-about .js-project-carousel-dot").removeClass("active");
          return false;
        });
      }
    }
  })();
})(jQuery);

$(document).ready(function() {
  hugmun.init();
});